import { Factory } from 'rosie';
import moment from 'moment';
import '../conversation_item_factory';

Factory.define('AIAssistantMessage')
  .attr('type', 'AI_ASSISTANT_MESSAGE');

Factory.define('AIAssistantMessageWithDefaults')
  .extend('AIAssistantMessage')
  .attr('advice', ['piece-of-advice'])
  .attr('sentAt', () => moment().toISOString())
  .attr('sessionId', 'default-chat-session-id')
  .attr('sessionItemId', 'default-chat-session-item-id')
  .attr('guideId', 'default-guide-id')
  .attr('guideType', 'TRANSACTION_GUIDE')
  .attr('original', 'mock-message')
  .attr('rephrased', 'mock-message')
  .attr('causedByItems', []);


Factory.define('AIAssistantMessageItemWithDefaults')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('AIAssistantMessageWithDefaults', content))
  .attr('initiator', {
    type: 'SYSTEM',
    id: 'SIDEKICK_V2',
  });
